export const ON_DEVICE_CONTROLS = ["kiosk", "operator"] as const;
export type OnDeviceControls = (typeof ON_DEVICE_CONTROLS)[number];

export const KIOSK_EXIT_PIN_PATTERN = /^\d{4,8}$/;

/**
 * Per-device kiosk mode (CB-153). Default OFF: a device runs as a normal
 * escapable/windowed player with on-device operator controls until kiosk mode
 * is switched on for it in the web fleet config. Previously every claimed
 * player was hardcoded to kiosk, which trapped desktop PCs full-screen with no
 * way to multitask.
 */
export function deviceKioskMode(settings: unknown): boolean {
  return (settings as { kioskMode?: boolean } | undefined)?.kioskMode === true;
}

export function resolveOnDeviceControls(settings: unknown): OnDeviceControls {
  return deviceKioskMode(settings) ? "kiosk" : "operator";
}

export function onDeviceControlsLocked(settings: unknown): boolean {
  return deviceKioskMode(settings);
}

export function validateKioskExitPin(pin: string): string | null {
  if (!KIOSK_EXIT_PIN_PATTERN.test(pin)) {
    return "Exit PIN must be 4–8 digits";
  }
  return null;
}

export function deviceHasExitPin(settings: unknown): boolean {
  return Boolean(
    (settings as { kioskExitPinHash?: string } | undefined)?.kioskExitPinHash,
  );
}

export function deviceIsActive(settings: unknown): boolean {
  return (settings as { active?: boolean } | undefined)?.active !== false;
}

export function deviceEnabledChannelsFromSettings(
  settings: unknown,
): string[] {
  const ALL = ["music", "ads", "announcements", "video"] as const;
  const ec = (settings as { enabledChannels?: unknown } | undefined)?.enabledChannels;
  if (Array.isArray(ec)) {
    return ALL.filter((c) => ec.includes(c));
  }
  return [...ALL];
}
